var _clipPath, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 100,
    height: 90
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 95c24.853 0 45-20.147 45-45S84.853 5 60 5C6.5 5 6 5 5 50c0 45 0 45 55 45z",
    fill: "#F0F1F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 95c24.853 0 45-20.147 45-45S84.853 5 60 5 15 25.147 15 50s20.147 45 45 45z",
    fill: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.286 11H24c-2.21 0-4 1.79-4 4v68c0 2.21 1.79 4 4 4h78.286c.946 0 1.714-.777 1.714-1.735v-72.53c0-.958-.768-1.735-1.714-1.735z",
    fill: "#fff",
    filter: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 75c0-1.105.895-2 2-2h18c1.105 0 2 .895 2 2v12H28V75zm30 0c0-1.105.895-2 2-2h18c1.105 0 2 .895 2 2v12H58V75zm30 0c0-1.105.895-2 2-2h18c1.105 0 2 .895 2 2v12H88V75z",
    fill: "#E8E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.19 11H24c-2.21 0-4 1.79-4 4v33h85V12.517c0-.402-.19-.788-.53-1.073-.34-.284-.8-.444-1.28-.444z",
    fill: "#7FBEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 48H20v20h85V48z",
    fill: "#5BA7B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 41.002l9.654-8.69c.22-.196.34-.48.33-.776l-.052-1.568c-.018-.54-.46-.966-1-.966H72v12z",
    fill: "#108060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 29h21l8 39H50V31c0-1.105.895-2 2-2z",
    fill: "#108060"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 68h31l-4.103-20H50v20z",
    fill: "#02614E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 68c11.046 0 20-8.954 20-20H28c0 11.046 8.954 20 20 20z",
    fill: "#CD5747"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 48H28c0 11.046 8.954 20 20 20 .675 0 1.342-.033 2-.1V48z",
    fill: "#EC856F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 17,
    width: 16,
    height: 6,
    rx: 2,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 15,
    y: 7,
    width: 94,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomize);
export default __webpack_public_path__ + "static/media/customize.e60ac8dcb71df75625a50368b2b41697.svg";
export { ForwardRef as ReactComponent };